module.exports = __webpack_public_path__ + "static/media/fonticons-fi.f29104c7.svg";